import Select from "../../baseComps/Select.tsx";
import { formaters } from "vincent-utils";
import { DateTime } from "luxon";
import RecycleBin from "../../assets/recycle-bin.svg?react";
import { RdvTypeEnums, RdvTypeValues } from "cadendar-shared";
import styles from "./AptCaracsEdit.module.css";
import PencilEdit01Icon from "../icons/pencil-edit-01-stroke-rounded.tsx";
import classNames from "classnames";
import OkButton from "../buttons/OkButton.tsx";
import { Select4 } from "shared-components";
import _ from "underts";

interface AptEditHeaderProps {
  name: string;
  forename: string;
  date: Date;
  onCancelEdit: () => void;
  onPatientEditClick: () => void;
}
const AptEditHeader = (props: AptEditHeaderProps) => {
  return (
    <div className={styles.topBar}>
      <div>
        <div className={styles.spacer}>
          <div className={styles.patientName}>
            {props.name?.toLocaleUpperCase("fr") +
              " " +
              (props.forename && props.forename
                ? formaters.capitaliseEveryFirstLetter(props.forename)
                : "")}
            <PencilEdit01Icon
              color="white"
              style={{ paddingTop: 3, cursor: "pointer" }}
              onClick={props.onPatientEditClick}
            />
          </div>

          <span className={styles.circle} onClick={props.onCancelEdit}>
            <svg
              width="800px"
              height="800px"
              viewBox="0 0 19 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={styles.icon}
            >
              <path
                className={styles.icon}
                d="M6 6L18 18M18 6L6 18"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
      <div>
        <div>
          <div className={styles.date}>
            {formaters.capitaliseEveryFirstLetter(
              DateTime.fromJSDate(props.date)
                .setLocale("fr")
                .toFormat("cccc dd LLL y")
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

interface AptCaracsEditProps {
  apt: {
    date: Date;
    name: string;
    forename: string;
    duration: number;
    hour: number;
    minute: number;
    type: RdvTypeValues;
    object: string;
    reminderChecked: boolean;
    confirmChecked: boolean;
  };
  cancelEnabled: boolean;
  hmPossibles: { hour: number; minute: number }[];
  dureesPossibles: number[];
  remindersCheckboxEnabled: boolean;
  confirmCheckboxEnabled: boolean;
  onSetDuree: (duree: number) => void;
  onSetType: (type: RdvTypeValues) => void;
  onSetObjet: (objet: string) => void;
  onToggleReminder: () => void;
  onToggleConfirm: () => void;
  onSetHM: (hm: { hour: number; minute: number }) => void;
  onCancel: () => void;
  onCancelEdit: () => void;
  onSave: () => void;
  onEditPatient: () => void;
}

const AptCaracsEdit = (props: AptCaracsEditProps) => {
  const { apt } = props;
  return (
    <div className={styles.container}>
      <AptEditHeader
        date={apt.date}
        name={apt.name || ""}
        forename={apt.forename || ""}
        onCancelEdit={props.onCancelEdit}
        onPatientEditClick={props.onEditPatient}
      />
      <div className={styles.body}>
        <div className={styles.bodySpacer}>
          <div>
            <div className={styles.formLabel}>Heure</div>
            <Select
              value={
                formaters.formatHMObjectForDisplay({
                  heure: apt.hour,
                  minute: apt.minute,
                }) || "0:00"
              }
              onChange={(event) => {
                const splitted = event.target.value.split(":");
                const hour = parseInt(splitted[0]);
                const minute = parseInt(splitted[1]);
                props.onSetHM({ hour, minute });
              }}
            >
              {props.hmPossibles.map((hm) => (
                <option
                  value={formaters.formatHourMinuteObjectForDisplay(hm)}
                  key={JSON.stringify(hm)}
                >
                  {formaters.formatHourMinuteObjectForDisplay(hm)}
                </option>
              ))}
            </Select>
          </div>
          <div>
            <div className={styles.formLabel}>Durée</div>
            <Select
              value={apt.duration || 0}
              onChange={(event) => {
                props.onSetDuree(parseInt(event.target.value));
              }}
            >
              {props.dureesPossibles.map((duree) => (
                <option value={duree} key={duree}>
                  {duree}
                </option>
              ))}
            </Select>
          </div>
          <div className="">
            <div className={styles.formLabel}>Type</div>
            <Select4
              items={_.sortBy(RdvTypeEnums.items, (item) => item.label)}
              onSelect={(key: typeof RdvTypeEnums.keyType) => {
                const parsed = RdvTypeEnums[key];
                if (!parsed) {
                  console.error("parsed", parsed);
                  throw new Error("parsed is undefined");
                }
                props.onSetType(parsed);
              }}
              defaultKey="PCONSULT"
              selected={RdvTypeEnums.key(apt.type)}
              className={styles.select}
            />
          </div>
        </div>

        <div>
          <label htmlFor="objetInput" className={styles.formLabel}>
            Objet
          </label>
          <input
            type="text"
            value={apt.object}
            id={"objetInput"}
            className={styles.input}
            onChange={(event) => {
              props.onSetObjet(event.target.value);
            }}
          />
        </div>
        <div className={styles.checkBoxBar}>
          <div className={styles.flex}>
            <input
              type="checkbox"
              checked={apt.reminderChecked}
              onChange={props.onToggleReminder}
              className={styles.checkBox}
              disabled={!props.remindersCheckboxEnabled}
            />

            <div
              onClick={props.onToggleReminder}
              className={classNames(
                {
                  [styles.formLabel]: true,
                  [styles.disabled]: !props.remindersCheckboxEnabled,
                },
                styles.clickable
              )}
            >
              Rappel
            </div>
          </div>
          <div className={styles.flex}>
            <input
              type="checkbox"
              checked={apt.confirmChecked}
              onChange={props.onToggleConfirm}
              className={styles.checkBox}
              disabled={!props.confirmCheckboxEnabled}
            />
            <div
              onClick={props.onToggleConfirm}
              className={classNames(
                {
                  [styles.formLabel]: true,
                  [styles.disabled]: !props.confirmCheckboxEnabled,
                },
                styles.clickable
              )}
            >
              Demande confirm.
            </div>
          </div>
        </div>

        <div className={styles.buttonGroup}>
          {props.cancelEnabled ? (
            <button
              className={`${styles.button} ${styles.colorDanger}`}
              onClick={props.onCancel}
            >
              <RecycleBin className={styles.buttonIcon} />
              Supprimer
            </button>
          ) : null}
          <OkButton onClick={props.onSave} label="Enregistrer" />
        </div>
      </div>
    </div>
  );
};

export default AptCaracsEdit;
